import React from "react";
import { isMobile } from "react-device-detect";
import { useBottomNavigator } from "utils/hooks/misc";
import styled, { useTheme } from "styled-components";
import { Inset } from "@shared/types";
import { CornixDashboardLogo } from "common/Icons/Icons.tsx";
import { useTelegramSafeAreaInsets } from "utils/hooks/useTelegramWebApp.ts";
import { IS_TELEGRAM_WEB_APP } from "features/telegram/constants.ts";

/** Whether the Mini App's top band (and its logo) shows: on a phone in
    Telegram. */
export const useShowsTelegramAppHeader = (): boolean => {
  const bottomNavigatorData = useBottomNavigator();
  return (
    IS_TELEGRAM_WEB_APP && !!bottomNavigatorData.baseShouldDisplay && isMobile
  );
};

const TelegramAppHeader = () => {
  const theme = useTheme();
  const showsHeader = useShowsTelegramAppHeader();
  const { safeAreaInset, contentSafeAreaInset } = useTelegramSafeAreaInsets();

  if (!showsHeader) return null;

  return (
    <div>
      {!!safeAreaInset?.top && (
        <StatusBarPlaceholder $safeAreaInset={safeAreaInset} />
      )}
      <InnerWrapper $contentSafeAreaInset={contentSafeAreaInset}>
        <CornixDashboardLogo
          primaryColor={theme.colors.primaryGrey}
          secondaryColor={theme.colors.primaryBlue}
          style={{ height: 20 }}
        />
      </InnerWrapper>
    </div>
  );
};

export default TelegramAppHeader;

const StatusBarPlaceholder = styled.div<{
  $safeAreaInset?: Inset;
}>`
  background-color: black;
  height: ${(p) => p.$safeAreaInset?.top || 0}px !important;
`;
const InnerWrapper = styled.div<{
  $contentSafeAreaInset?: Inset;
}>`
  background-color: ${(p) => p.theme.colors.bgColor};
  height: ${(p) => p.$contentSafeAreaInset?.top || 0}px !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;
